import { isPlainObject as f, isString as b, isFunction as g, isNumber as m } from "./index38.js";
function h(l, r, a, s) {
  var v, u = [l, r, a, s], n = f(l) ? l.event : l;
  if (!n || !b(n))
    throw new Error("Event missing");
  var e = f(l) ? (v = l.properties) !== null && v !== void 0 ? v : {} : f(r) ? r : {}, i = {};
  g(a) || (i = a ?? {}), f(l) && !g(r) && (i = r ?? {});
  var t = u.find(g);
  return [n, e, i, t];
}
function k(l, r, a, s, v) {
  var u, n, e = null, i = null, t = [l, r, a, s, v], d = t.filter(b);
  d[0] !== void 0 && d[1] !== void 0 && (e = d[0], i = d[1]), d.length === 1 && (e = null, i = d[0]);
  var c = t.find(g), o = t.filter(function(A) {
    return i === null ? f(A) : f(A) || A === null;
  }), _ = (u = o[0]) !== null && u !== void 0 ? u : {}, C = (n = o[1]) !== null && n !== void 0 ? n : {};
  return [
    e,
    i,
    _,
    C,
    c
  ];
}
var P = function(l) {
  return function() {
    for (var r, a, s, v, u, n = [], e = 0; e < arguments.length; e++)
      n[e] = arguments[e];
    var i = null;
    i = (s = (r = n.find(b)) !== null && r !== void 0 ? r : (a = n.find(m)) === null || a === void 0 ? void 0 : a.toString()) !== null && s !== void 0 ? s : l.id();
    var t = n.filter(function(_) {
      return i === null ? f(_) : f(_) || _ === null;
    }), d = (v = t[0]) !== null && v !== void 0 ? v : {}, c = (u = t[1]) !== null && u !== void 0 ? u : {}, o = n.find(g);
    return [i, d, c, o];
  };
};
function w(l, r, a, s) {
  m(l) && (l = l.toString()), m(r) && (r = r.toString());
  var v = [l, r, a, s], u = v.filter(b), n = u[0], e = n === void 0 ? l : n, i = u[1], t = i === void 0 ? null : i, d = v.filter(f)[0], c = d === void 0 ? {} : d, o = v.find(g);
  return [e, t, c, o];
}
export {
  w as resolveAliasArguments,
  h as resolveArguments,
  k as resolvePageArguments,
  P as resolveUserArguments
};
//# sourceMappingURL=index12.js.map
